/* eslint-disable */

(function() {
  "use strict";

  $(".js-footer-accordion-btn").click(function() {
    if (window.matchMedia("(max-width: 991px)").matches) {
      $(this)
        .toggleClass("is-active");
      $(this)
        .siblings(".js-footer-accordion-body")
        .slideToggle();
    }
  });

})();